export type MsalAuthConfig = {
    client_id: string;
    authority: string;
    redirect_uri: string;
    post_logout_redirect_uri: string;
    scopes: string[];
    cacheLocation?: 'sessionStorage' | 'localStorage';
    storeAuthStateInCookie?: boolean;
    response_mode?: string; 
};

export type AuthenticationProviderProps = {
  config: MsalAuthConfig;
  children?: JSX.Element;
};

export type AuthenticationContextType = {
  handleLoginButtonClick: () => void;
  authConfig: MsalAuthConfig;
  authCallbackConfig: MsalAuthConfig;
  authCallbackRoute: JSX.Element;
};

export enum RedirectionType {
  Signin = "signin",
  Signout = "signout",
  SigninCallback = "signinCallback"
}
